var map = {
	"./icon_ranking_1.png": "7649",
	"./icon_ranking_2.png": "749e",
	"./icon_ranking_3.png": "9122",
	"./icon_ranking_4.png": "4aca",
	"./icon_ranking_5.png": "abff0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a9c";